/**
 * Kennzeichen einer ausführbaren Checkliste aus dem Pflichtenregister, deren Prüfpunkte noch nicht fachlich
 * freigegeben sind (`unreleased`, tri-server `createRegisterExecutableInstance`). Abzeichenbar ist sie
 * trotzdem (Entscheidung C, 02.11.2026) — darum muss der Hinweis dort stehen, wo sie abgearbeitet wird.
 * Dieselbe Plakette wie in der Vorschau (`ChecklistPreviewDialog`).
 */
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";

export default function RegisterChecklistUnreleasedBadge({ checklist, className }: { checklist: any; className?: string }) {
  const { t } = useTranslation();
  if (checklist?.unreleased !== true) return null;
  return (
    <Badge variant="warning" className={className} data-testid="register-checklist-unreleased">
      {t("operatorObligationsPanel.checklistPreview.checklistUnreleased")}
    </Badge>
  );
}
